export default {
  mediaChannel: 'Canal de Mídia',
  min: 'Mín',
  max: 'Máx'
}
